import { CloseButton } from '@components/utility/buttons';
import { Dialog, dialogClasses, DialogContent } from '@mui/material';
import { getYoutubeId } from '@utils/common';

type YouTubeVideoDialogProps = {
    videoId?: string | null;
    fullUrl?: string | null;
    onClose: () => void;
};

export const YouTubeVideoDialog = ({ videoId, fullUrl, onClose }: YouTubeVideoDialogProps) => {
    const resolvedVideoId = fullUrl ? getYoutubeId(fullUrl) : videoId;

    return (
        <Dialog
            open={Boolean(resolvedVideoId)}
            onClose={onClose}
            aria-label="Video player"
            sx={{
                [`& .${dialogClasses.paper}`]: {
                    aspectRatio: '16 / 9',
                    borderRadius: '28px',
                },
            }}
        >
            <DialogContent
                className="aspect-[calc(16/9)]"
                sx={{ px: { xs: 0, md: '140px' }, py: { xs: 0, md: '90px' } }}
            >
                {resolvedVideoId && (
                    <>
                        <CloseButton filled onClick={onClose} />
                        <iframe
                            src={`https://www.youtube.com/embed/${resolvedVideoId}?autoplay=1`}
                            title="Video"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            className="h-full w-full rounded"
                        />
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};
